import { AbovoIconProp, ApprovalRequest } from '@abovo/shared-models';
import { FontAwesomeIconsModule } from '@abovo/shared-ui-components';
import { ApprovalRequestStore } from '@abovo/webvis-data-access';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RequestStatusSlugs } from '../constants/approval-request.constants';

@Component({
   selector: 'webvis-feature-approval-status-badge',
   changeDetection: ChangeDetectionStrategy.OnPush,
   imports: [TranslatePipe, FontAwesomeIconsModule, CommonModule],
   template: `
      @if (approvalStatus()?.slug; as statusSlug) {
         <div
            [ngClass]="'status__' + statusSlug"
            class="flex items-center gap-1 px-3 py-1 rounded-md border"
         >
            @if (approvalRequestStore.loading()) {
               <fa-icon
                  [icon]="['fas', 'circle-notch']"
                  class="animate-spin"
               ></fa-icon>
            } @else {
               <fa-icon [icon]="statusIcon()"></fa-icon>
            }
            {{ 'approval.status_' + statusSlug | translate }}
         </div>
      } @else {
         -
      }
   `,
   styles: `
      .status__cancelled {
         border-color: var(--sys-outline);
         background-color: var(--sys-surface-container-highest);
      }
      .status__pending {
         border-color: var(--sys-primary);
         background-color: var(--sys-primary-container);
         color: var(--sys-on-primary-container);
      }
      .status__draft {
         border-color: var(--sys-outline);
         background-color: var(--sys-surface-container-highest);
         color: var(--sys-on-surface);
      }
      .status__rejected {
         border-color: var(--sys-error);
         background-color: var(--sys-error-container);
         color: var(--sys-on-error-container);
      }
      .status__approved {
         border-color: var(--extended-safe);
         background-color: var(--extended-safe-container);
         color: var(--extended-on-safe-container);
      }
   `,
})
export class ApprovalStatusBadgeComponent {
   approvalRequestStore = inject(ApprovalRequestStore);

   // The badge only reads the status, so accept anything that carries one (e.g. ApprovalRequestDialogInput)
   approvalStatus = input<ApprovalRequest['status'] | null>(null);

   statusIcon: Signal<AbovoIconProp> = computed(() => {
      const currentStatus = this.approvalStatus()?.slug;
      switch (currentStatus) {
         case RequestStatusSlugs.draft:
            return ['fas', 'file-pen'];
         case RequestStatusSlugs.approved:
            return ['fas', 'circle-check'];
         default:
            return ['fas', 'hourglass-start'];
      }
   });
}
